import { atom } from "recoil";

import { persistAtom } from "./persist";

// ponytail: opt-in only, no bucketing. For a randomized holdout, change this
// default to a hash of the user id mod 100 < N. persistAtom keeps the
// assignment sticky and no consumer changes.
export const NewNavOptInState = atom<boolean>({
  key: "NewNavOptIn_v1",
  default: false,
  effects_UNSTABLE: [persistAtom],
});
